// extracted by mini-css-extract-plugin
export default {"updateInstrumentsFeedbackContainer":"InstrumentsPage-module_updateInstrumentsFeedbackContainer_eR7yvp"};